/* globals $ */

export default () => {
  $('.datepicker').pickadate({
    monthsFull: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    monthsShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jui', 'Jui', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
    weekdaysFull: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    weekdaysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    labelMonthNext: 'Prochain mois',
    labelMonthPrev: 'Mois précédent',
    labelMonthSelect: 'Sélectionnez un mois',
    labelYearSelect: 'Sélectionnez une année',
    format: 'd mmmm yyyy',
    firstDay: 1,
    today: '',
    clear: '',
    close: '',
  });
};
